export enum MailTime {
  Daily = 'daily',
  Weekly = 'weekly',
  Always = 'always',
  Never = 'never',
}
